module.exports = __webpack_public_path__ + "img/image31.048ce6df.png";